class ReviewCollapse {
	constructor(elem) {
		this.block = elem;
		this.trigger = null;
		this.isSmooth = false;
	}

	init() {
		let _this = this;
		this.block.after('<div class="review__trigger" />');
		this.trigger = this.block.next('.review__trigger');
		this.trigger.text(this.block.data('review-expand'));

		this.isSmooth = this.block.data('review-smooth');

		this.trigger.click(function () {
			if (!_this.block.hasClass('expanded')) {
				_this.block.addClass('expanded');
				$(this).text(_this.block.data('review-collapse'));
				if (_this.isSmooth) _this.block.slideDown(200);
			} else {
				_this.block.removeClass('expanded');
				$(this).text(_this.block.data('review-expand'));
				if (_this.isSmooth) _this.block.slideUp(200);
			}
		});
	}
}

export {ReviewCollapse}

$(document).on('load', () => {
	let reviewCollapses = [];
	if ($('[data-review-expand]').length > 0) {
		$('[data-review-expand]').each(function (i) {
			reviewCollapses[i] = new ReviewCollapse($(this));
			reviewCollapses[i].init();
		});
	}
});
